/**
 * @note Is this truly needed? Validation systems should be reviewed, inputs should handle minimum values in forms automatically.
 * @param value 
 * @returns 
 */
export const isGreaterThanZero = (value: number) => value > 0
